 import React, { useEffect, useRef, useState } from 'react';
import { PricingContainer } from "./styles.js";
import { Icon } from 'antd';
import { getPricingPlans } from '../../utils/services/authAPI.js';
import { withTranslation } from 'react-i18next';
import { PRICING_PLAN } from './translationValues.js';

const NAMESPACES = ['PRICING_PLAN'];

function PricingPlan(props) {
  const { selectedPricingPlan, setSelectedPricingPlan, t } = props;
  const [showPlanList, setShowPlanList] = useState(false);
  const dropdownPosition = useRef('bottom');
  const [plan, setPlan] = useState({
    //plan details of free plan
    priceId: null,
    currency: null,
    price: 0,
    interval: "month"
  });
  const [stripePlansList, setStripePlansList] = useState([]);
  const menuRef = useRef();

  //Get pricing plans
  const pricingPlans = async () => {
    let plansArr = [];
    const { pricing_table_items } = await getPricingPlans();   

    pricing_table_items && pricing_table_items.map((plan, index) => {
      let selectedPlan = plansArr.filter(p => p.name === plan.name);
      //If plan already exists
      if(selectedPlan.length > 0) {
        //Filter the correct plan to update the plan interval. only interval changes w.r.t plans. Currency remains the same.
        let currentInterval = selectedPlan[0].interval; //Get current interval of the existing plan
        let recurringPlan = { [plan.recurring.interval]: plan.amount, priceId: plan.price_id }; //The plan interval to be added to the currentInterval
        let updatedInterval;
        //Add the interval to the start if interval = month. 
        //In the dropdown, we display the monthly plan first 
        //followed by yearly plan for a particular plan(Standard, Premium)
        if(plan.recurring.interval === "month") {
          updatedInterval = [ recurringPlan, ...currentInterval];
        } else {
          updatedInterval = [ ...currentInterval, recurringPlan];
        }
        selectedPlan[0].interval = updatedInterval;
      } else {
        //If plan does not exist in plansArr, create new plan obj and adding to plansArr
        let planObj = {
            name: plan.name,
            interval: [{ [plan.recurring.interval]: plan.amount, priceId: plan.price_id }],
            currency: plan.currency,
        };
        plansArr = [ ...plansArr, planObj ];
      }
    });
    
    //Looping through the plansArr to arrange the plans in the order: 1. Free plan, 2. Standard, 3. Premium
    plansArr.map((p, i) => {
      let planName = p.name;
      if(planName === "Free Plan" && i !== 0) {
        let p = plansArr.splice(i, 1);
        plansArr.unshift(...p);
      } else if(planName === "Premium" && i !== plansArr.length - 1) {
        let p = plansArr.splice(i, 1);
        plansArr.push(...p);
      }
    });
    setStripePlansList(plansArr);

    //Setting the plan user selected from the list of plans on component mount
    plansArr.map(plan => {
      return plan.interval.filter(int => {        
        if(int.priceId === selectedPricingPlan) {
          let userPlan = {
            priceId: int.priceId,
            currency: plan.currency.toUpperCase(),
            price: convertPrice(Object.values(int)[0]),
            interval: Object.keys(int)[0]
          }
          setPlan(userPlan);
          setSelectedPricingPlan(userPlan.priceId);
        }else if(selectedPricingPlan === 'free' && plan.name==='Free' ){       
          setSelectedPricingPlan(int.priceId);
        }
      })
    });
  };

  //Convert plan pricing from cents to dollars
  const convertPrice = (amount) => {
    return (amount/100).toFixed(2);
  } 

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClicks);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClicks);
    };
  }, [showPlanList]);

  useEffect(() => {
    pricingPlans();
  }, []);
  
  const handleOutsideClicks = event => {
    if (showPlanList && menuRef.current && !menuRef.current.contains(event.target)) {
      setShowPlanList(false);
    }
  };

  //On selecting a plan from dropdown, set the plan to state
  const selectedPlan = (priceId, currency, price, interval) => {
    let planObj = {
      priceId,
      currency,
      price,
      interval
    };
    setPlan(planObj);
    setSelectedPricingPlan(priceId);
  };

  //Check if pricing plan dropdown should be displayed below or above the input
  const displayDropdown = () => {
    let element = document.querySelector('.dropDown-list');
    let rect = element.getBoundingClientRect();
    
    //Determine if the pricing plan dropdown should be below or above the displayed plan 
    if(rect.bottom > window.innerHeight) {
      dropdownPosition.current = 'top';
    } else {
      dropdownPosition.current = 'bottom';
    }    
    setShowPlanList(!showPlanList);
  } 

  return (
    <PricingContainer pos={dropdownPosition.current}>
      <div className="select-plan">
        <div className="plan-label glacial">{t(PRICING_PLAN.PLAN_SELECTED_DESCRIPTION.key, PRICING_PLAN.PLAN_SELECTED_DESCRIPTION.value)}</div>
        <div
          className="plan-list"
          onClick={() => {
            displayDropdown();
          }}
          ref={menuRef}
        >
          <div className="selected-plan">
            {plan.currency} {plan.price === 0 ? plan.price.toFixed(2) : plan.price}
          </div>
          <div className="month-label">
            per <br /> {plan.interval}
          </div>
          <div>
            <Icon type="down" />
          </div>
          <ul class={`dropDown-list ${showPlanList ? 'show-list' : ''}`}>
            {
              stripePlansList.map((plan, index) => {
                let planName = plan.name; //get the plan name
                let interval = plan.interval; //get the interval list of planName
                let currency = plan.currency.toUpperCase(); //get currency name of the planName
                
                return (
                  <li className="plans-list" key={`plan${index}`}>
                    <h5 className="plan-name">{planName}</h5>
                    {/* <hr /> */}
                    <ul className="plans-category">
                      {
                        interval.map((p, i) => {
                          return (
                            <li 
                            className="plans-category-list"
                            onClick={() => selectedPlan(p.priceId, currency, (Object.values(p)[0]/100).toFixed(2), Object.keys(p)[0])}
                            key={`interval${i}`}
                            >
                              {currency} {(Object.values(p)[0]/100).toFixed(2)} / {Object.keys(p)[0]}
                            </li>
                          )
                        })
                      }
                    </ul>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
    </PricingContainer>
  )
}

export default withTranslation(NAMESPACES)(PricingPlan);
